var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6279 54.6278C67.1248 42.1309 67.1248 21.8695 54.6279 9.37262C42.131 -3.12425 21.8696 -3.12425 9.37271 9.37262C-3.12417 21.8695 -3.12417 42.1309 9.37271 54.6278C21.8696 67.1247 42.131 67.1247 54.6279 54.6278Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8154 41.2617C35.8154 45.6124 39.3426 49.1396 43.6933 49.1396C48.044 49.1396 51.5701 45.6124 51.5701 41.2617C51.5701 36.911 48.0429 33.3838 43.6933 33.3838C39.3437 33.3838 35.8154 36.911 35.8154 41.2617Z",
    fill: "#D1D3D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7689 17.2914C50.7689 14.845 48.785 12.8623 46.3376 12.8623C43.8912 12.8623 41.9062 14.845 41.9062 17.2914C41.9062 19.74 43.8901 21.7227 46.3376 21.7227C48.785 21.7227 50.7689 19.74 50.7689 17.2914Z",
    fill: "#A7A9AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7529 34.6158C53.7529 39.4799 56.8363 43.6131 61.1495 45.2028C62.9765 41.1767 64.001 36.709 64.001 32.0006C64.001 29.0706 63.5992 26.2357 62.8617 23.5398C57.6709 24.5576 53.7529 29.1269 53.7529 34.6158Z",
    fill: "#D1D3D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5517 40.1235C10.5517 39.1377 9.75239 38.3395 8.76655 38.3395C7.78071 38.3395 6.98145 39.1377 6.98145 40.1235C6.98145 41.1094 7.78071 41.9086 8.76655 41.9086C9.75239 41.9075 10.5517 41.1094 10.5517 40.1235Z",
    fill: "#D1D3D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5535 26.7391C52.5535 25.7532 51.7553 24.954 50.7695 24.954C49.7836 24.954 48.9844 25.7521 48.9844 26.7391C48.9844 27.7249 49.7847 28.5231 50.7695 28.5231C51.7553 28.5231 52.5535 27.7249 52.5535 26.7391Z",
    fill: "#D1D3D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 48.1537C12.4004 50.6012 14.3842 52.5828 16.8306 52.5828C19.277 52.5828 21.2619 50.6012 21.2619 48.1537C21.2619 45.7063 19.277 43.7224 16.8306 43.7224C14.3853 43.7235 12.4004 45.7063 12.4004 48.1537Z",
    fill: "#D1D3D4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4453 10.5837C29.4453 12.148 30.7127 13.4143 32.2759 13.4143C33.8391 13.4143 35.1064 12.1469 35.1064 10.5837C35.1064 9.02159 33.8391 7.75424 32.2759 7.75424C30.7116 7.75424 29.4453 9.02159 29.4453 10.5837Z",
    fill: "#D1D3D4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4732 62.2392C41.5624 56.917 36.9368 52.8621 31.3552 52.8621C25.9303 52.8621 21.403 56.6907 20.3145 61.7899C23.9366 63.2129 27.8755 64.0011 32.001 64.0011C35.6684 64 39.19 63.3752 42.4732 62.2392Z",
    fill: "#A7A9AC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9079 31.262C17.2386 31.262 19.9388 28.5617 19.9388 25.2311C19.9388 21.9004 17.2374 19.2001 13.9079 19.2001C10.5783 19.2001 7.87695 21.9004 7.87695 25.2311C7.87695 28.5617 10.5783 31.262 13.9079 31.262Z",
    fill: "#A7A9AC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5878 25.9078C32.5878 24.922 31.7885 24.1238 30.8027 24.1238C29.8168 24.1238 29.0176 24.922 29.0176 25.9078C29.0176 26.8936 29.8168 27.6929 30.8027 27.6929C31.7885 27.6929 32.5878 26.8947 32.5878 25.9078Z",
    fill: "#D1D3D4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9214 38.5857C25.3571 38.5857 24.0908 39.8519 24.0908 41.4151C24.0908 42.9795 25.3582 44.2446 26.9214 44.2446C28.4846 44.2446 29.7508 42.9795 29.7508 41.4151C29.7508 39.8519 28.4846 38.5857 26.9214 38.5857Z",
    fill: "#D1D3D4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57.8707 13.1736C49.0589 26.5889 29.1224 53.0277 8.48828 53.7C14.3349 60.0335 22.7029 64.0011 32.0005 64.0011C49.6738 64.0011 64.001 49.675 64.001 32.0006C63.9999 24.9617 61.7224 18.4571 57.8707 13.1736Z",
    fill: "#212A3C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.9375 30.0642C54.5472 42.6991 36.3483 61.2224 12.4111 57.2968C17.8261 61.4962 24.6199 64.0011 32.0009 64.0011C49.6743 64.0011 64.0015 49.675 64.0015 32.0006C64.0004 31.3492 63.9761 30.7045 63.9375 30.0642Z",
    fill: "#212A3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.bd85477ac1152eacece7679d2bc01285.svg";
export { ForwardRef as ReactComponent };